// removed by extract-text-webpack-plugin
module.exports = {"action":"styles__action___2vy_Y","actionError":"styles__actionError___H_kV2","details":"styles__details___LRT7M","rightMargin":"styles__rightMargin___1TQFE","information":"styles__information___1tfiy","tableInformation":"styles__tableInformation___1qDXh","acompanhamento":"styles__acompanhamento___2zjNF","itensSeparation":"styles__itensSeparation___1R_A6","titleDetails":"styles__titleDetails___2PQEX","detailsRescheduling":"styles__detailsRescheduling___1vrMn"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/IncidentManager/components/ReOpenSolicitationModal/styles.css
// module id = 2760
// module chunks = 0